import { BaseRouteService } from 'core/services';

class CoreUserRouteService extends BaseRouteService {
    constructor() {
        super('core-users');
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields}', filter);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    updateUserSetting(resource) {
        return super.update(`${this.base}/update-user-setting`, resource);	
    }
}

export default CoreUserRouteService;
